// SPDX-License-Identifier: AGPL-3.0-or-later

import {ApplicationCommandSnowflake} from '@fluxer/schema/src/domains/application_command/ApplicationCommandSchemas';
import {IsoTimestampStringType} from '@fluxer/schema/src/primitives/DateValidators';
import {z} from 'zod';

export const InteractionDeliveryStatus = z.enum([
	'RESERVED',
	'PREPARED',
	'DISPATCHING',
	'ENQUEUED',
	'NOT_DELIVERED',
	'DELIVERY_UNKNOWN',
]);
export type InteractionDeliveryStatus = z.infer<typeof InteractionDeliveryStatus>;

// What the invoking user learns: never the token, the options or the bot's answer.
export const InteractionInvokeResponse = z.strictObject({
	id: ApplicationCommandSnowflake,
	status: InteractionDeliveryStatus,
	deadline_at: IsoTimestampStringType,
});
export type InteractionInvokeResponse = z.infer<typeof InteractionInvokeResponse>;
